var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { CircularProgress, Typography, Menu, MenuItem } from "@mui/material";
import { Publish, RotateLeft, PlayCircle, PauseCircle, StopCircle } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Dialog } from "@sequentech/ui-essentials";
import { Button, FilterButton, SelectColumnsButton, useRecordContext } from "react-admin";
import { EPublishActionsType, EPublishType } from "./EPublishType";
import { PublishStatus, ElectionEventStatus, nextStatus } from "./EPublishStatus";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { EPublishActions } from "@/types/publishActions";
import { VotingStatusChannel } from "@/gql/graphql";
import { EInitializeReportPolicy, EVotingPeriodEnd, EVotingStatus, } from "@sequentech/ui-core";
import { usePublishPermissions } from "./usePublishPermissions";
import PublishExport from "./PublishExport";
var PublishActionsStyled = {
    Container: styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: flex;\n        margin-bottom: 8px;\n        justify-content: flex-end;\n        width: 100%;\n    "], ["\n        display: flex;\n        margin-bottom: 8px;\n        justify-content: flex-end;\n        width: 100%;\n    "]))),
};
export var StyledStatusButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &.MuiButtonBase-root {\n        line-height: 1 !important;\n    }\n\n    :disabled {\n        color: #ccc;\n        cursor: not-allowed;\n        background-color: #eee;\n    }\n"], ["\n    &.MuiButtonBase-root {\n        line-height: 1 !important;\n    }\n\n    :disabled {\n        color: #ccc;\n        cursor: not-allowed;\n        background-color: #eee;\n    }\n"])));
export var StyledMenuItem = styled(MenuItem)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    &.MuiMenuItem-root {\n        display: flex;\n        gap: 8px;\n    }\n"], ["\n    &.MuiMenuItem-root {\n        display: flex;\n        gap: 8px;\n    }\n"])));
export var PublishActions = function (_a) {
    var ballotPublicationId = _a.ballotPublicationId, publishType = _a.publishType, type = _a.type, status = _a.status, kioskModeEnabled = _a.kioskModeEnabled, onlineModeEnabled = _a.onlineModeEnabled, earlyVotingEnabled = _a.earlyVotingEnabled, telephoneVotingEnabled = _a.telephoneVotingEnabled, electionStatus = _a.electionStatus, electionPresentation = _a.electionPresentation, changingStatus = _a.changingStatus, onGenerate = _a.onGenerate, _b = _a.onPublish, onPublish = _b === void 0 ? function () { return null; } : _b, _c = _a.onChangeStatus, onChangeStatus = _c === void 0 ? function () { return null; } : _c, data = _a.data;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    var isGoldUser = authContext.isGoldUser, reauthWithGold = authContext.reauthWithGold;
    var canWrite = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_WRITE);
    var record = useRecordContext();
    var isVotingPeriodEndDisallowed = (electionPresentation === null || electionPresentation === void 0 ? void 0 : electionPresentation.voting_period_end) == EVotingPeriodEnd.DISALLOWED;
    var canChangeStatus = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_STATE_WRITE);
    // const [addWidget, setWidgetTaskId, updateWidgetFail] = useWidgetStore()
    var _d = useState(false), showDialog = _d[0], setShowDialog = _d[1];
    var _e = useState(""), dialogText = _e[0], setDialogText = _e[1];
    var _f = useState(null), currentCallback = _f[0], setCurrentCallback = _f[1];
    var _g = useState(null), startAnchorEl = _g[0], setStartAnchorEl = _g[1];
    var startMenuOpen = Boolean(startAnchorEl);
    var _h = useState(null), pauseAnchorEl = _h[0], setPauseAnchorEl = _h[1];
    var pauseMenuOpen = Boolean(pauseAnchorEl);
    var _j = useState(null), stopAnchorEl = _j[0], setStopAnchorEl = _j[1];
    var stopMenuOpen = Boolean(stopAnchorEl);
    var _k = usePublishPermissions(), canPublishRegenerate = _k.canPublishRegenerate, canPublishStartVoting = _k.canPublishStartVoting, canPublishPauseVoting = _k.canPublishPauseVoting, canPublishStopVoting = _k.canPublishStopVoting, canPublishChanges = _k.canPublishChanges, showPublishColumns = _k.showPublishColumns, showPublishFilters = _k.showPublishFilters;
    var IconOrProgress = function (_a) {
        var st = _a.st, Icon = _a.Icon;
        return nextStatus(st) === status && status !== PublishStatus.Void ? (_jsx(CircularProgress, { size: 16 })) : (_jsx(Icon, { width: 24 }));
    };
    var StatusButton = function (_a) {
        var st = _a.st, label = _a.label, onClick = _a.onClick, Icon = _a.Icon, disabledStatus = _a.disabledStatus, _b = _a.disabled, disabled = _b === void 0 ? false : _b, className = _a.className;
        return (_jsx(Button, { onClick: onClick, className: className, label: String(t(label)), style: changingStatus || (disabledStatus === null || disabledStatus === void 0 ? void 0 : disabledStatus.includes(status))
                ? {
                    overflow: "hidden",
                    color: "#ccc",
                    cursor: "not-allowed",
                    backgroundColor: "#eee",
                    padding: "6px 16px",
                }
                : {
                    overflow: "hidden",
                    padding: "6px 16px",
                }, disabled: disabled || (disabledStatus === null || disabledStatus === void 0 ? void 0 : disabledStatus.includes(status)) || st === status + 0.1, children: _jsx(IconOrProgress, { st: st, Icon: Icon }) }));
    };
    var openDialog = function (dialogText) {
        setDialogText(dialogText);
        setShowDialog(true);
    };
    // Handler for navigating after a re-authentication action.
    var reauthCallback = function (baseUrl, action, voting_channels) {
        if (publishType === EPublishType.Event) {
            var electionEventPublishTabIndex = localStorage.getItem("electionEventPublishTabIndex");
            baseUrl.searchParams.set("tabIndex", electionEventPublishTabIndex !== null && electionEventPublishTabIndex !== void 0 ? electionEventPublishTabIndex : "8");
        }
        else {
            var electionPublishTabIndex = localStorage.getItem("electionPublishTabIndex");
            baseUrl.searchParams.set("tabIndex", electionPublishTabIndex !== null && electionPublishTabIndex !== void 0 ? electionPublishTabIndex : "4");
        }
        sessionStorage.setItem(action, "true");
        if (voting_channels &&
            (action === EPublishActions.PENDING_START_VOTING ||
                action === EPublishActions.PENDING_PAUSE_VOTING ||
                action === EPublishActions.PENDING_STOP_VOTING)) {
            try {
                sessionStorage.setItem("".concat(action, "_CHANNELS"), JSON.stringify(voting_channels));
            }
            catch (e) {
                console.warn("Could not persist selected channels for re-auth", e);
            }
        }
    };
    /**
     * Specific Handler for Start/Pause/Stop Buttons:
     * Incorporates re-authentication logic for actions that require Gold-level permissions.
     */
    var handleChangeVotingPeriod = function (action, status, voting_channels) {
        var actionText = action === EPublishActions.PENDING_START_VOTING
            ? t("publish.action.startVotingPeriod")
            : action === EPublishActions.PENDING_STOP_VOTING
                ? t("publish.action.stopVotingPeriod")
                : t("publish.action.pauseVotingPeriod");
        var dialogMessage = isGoldUser()
            ? action === EPublishActions.PENDING_START_VOTING
                ? t("publish.dialog.startInfo")
                : action === EPublishActions.PENDING_STOP_VOTING
                    ? t("publish.dialog.stopInfo")
                    : t("publish.dialog.pauseInfo")
            : t("publish.dialog.confirmation", { action: actionText });
        openDialog(dialogMessage);
        setCurrentCallback(function () { return function () { return __awaiter(void 0, void 0, void 0, function () {
            var baseUrl, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!!isGoldUser()) return [3 /*break*/, 2];
                        baseUrl = new URL(window.location.href);
                        reauthCallback(baseUrl, action, voting_channels);
                        return [4 /*yield*/, reauthWithGold(baseUrl.toString())];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        onChangeStatus(status, voting_channels);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.error("Re-authentication failed:", error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); }; });
    };
    /**
     * Specific Handler for "Publish Changes" Button: Incorporates
     * re-authentication logic for actions that require Gold-level permissions.
     */
    var handlePublish = function (is_generate) {
        var actionText = t("publish.action.publish");
        var dialogMessage = isGoldUser()
            ? is_generate
                ? t("publish.dialog.info")
                : t("publish.dialog.publishInfo", { action: actionText })
            : t("publish.dialog.confirmation", { action: actionText });
        openDialog(dialogMessage);
        setCurrentCallback(function () { return function () { return __awaiter(void 0, void 0, void 0, function () {
            var baseUrl, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!!isGoldUser()) return [3 /*break*/, 2];
                        baseUrl = new URL(window.location.href);
                        reauthCallback(baseUrl, EPublishActions.PENDING_PUBLISH_ACTION);
                        return [4 /*yield*/, reauthWithGold(baseUrl.toString())];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        onGenerate();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        console.error("Re-authentication failed:", error_2);
                        setDialogText(t("publish.dialog.errorReauth"));
                        setShowDialog(true);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); }; });
    };
    /**
     * Checks for any pending actions after the component mounts. If a pending
     * action is found, it executes the action and removes the flag. Except to
     * publish action, which is handled in the useEffect of the parent
     * component.
     */
    useEffect(function () {
        var executePendingActions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var isGold, pendingStart, selectedChannels, channelsStr, pendingPause, selectedPauseChannels, channelsStr, pendingStop, selectedStopChannels, channelsStr, pendingStopKiosk;
            return __generator(this, function (_a) {
                if (!record) {
                    return [2 /*return*/];
                }
                isGold = isGoldUser();
                pendingStart = sessionStorage.getItem(EPublishActions.PENDING_START_VOTING);
                if (pendingStart) {
                    selectedChannels = undefined;
                    try {
                        channelsStr = sessionStorage.getItem("".concat(EPublishActions.PENDING_START_VOTING, "_CHANNELS"));
                        if (channelsStr) {
                            selectedChannels = JSON.parse(channelsStr);
                        }
                    }
                    catch (e) {
                        console.warn("Could not restore selected channels after re-auth", e);
                    }
                    isGold && onChangeStatus(ElectionEventStatus.Open, selectedChannels);
                    sessionStorage.removeItem(EPublishActions.PENDING_START_VOTING);
                    sessionStorage.removeItem("".concat(EPublishActions.PENDING_START_VOTING, "_CHANNELS"));
                }
                pendingPause = sessionStorage.getItem(EPublishActions.PENDING_PAUSE_VOTING);
                if (pendingPause) {
                    selectedPauseChannels = undefined;
                    try {
                        channelsStr = sessionStorage.getItem("".concat(EPublishActions.PENDING_PAUSE_VOTING, "_CHANNELS"));
                        if (channelsStr) {
                            selectedPauseChannels = JSON.parse(channelsStr);
                        }
                    }
                    catch (e) {
                        console.warn("Could not restore selected pause channels after re-auth", e);
                    }
                    isGold && onChangeStatus(ElectionEventStatus.Paused, selectedPauseChannels);
                    sessionStorage.removeItem(EPublishActions.PENDING_PAUSE_VOTING);
                    sessionStorage.removeItem("".concat(EPublishActions.PENDING_PAUSE_VOTING, "_CHANNELS"));
                }
                pendingStop = sessionStorage.getItem(EPublishActions.PENDING_STOP_VOTING);
                if (pendingStop) {
                    selectedStopChannels = undefined;
                    try {
                        channelsStr = sessionStorage.getItem("".concat(EPublishActions.PENDING_STOP_VOTING, "_CHANNELS"));
                        if (channelsStr) {
                            selectedStopChannels = JSON.parse(channelsStr);
                        }
                    }
                    catch (e) {
                        console.warn("Could not restore selected stop channels after re-auth", e);
                    }
                    isGold && onChangeStatus(ElectionEventStatus.Closed, selectedStopChannels);
                    sessionStorage.removeItem(EPublishActions.PENDING_STOP_VOTING);
                    sessionStorage.removeItem("".concat(EPublishActions.PENDING_STOP_VOTING, "_CHANNELS"));
                }
                pendingStopKiosk = sessionStorage.getItem(EPublishActions.PENDING_STOP_KIOSK_ACTION);
                if (pendingStopKiosk) {
                    isGold && onChangeStatus(ElectionEventStatus.Closed, [VotingStatusChannel.Kiosk]);
                    sessionStorage.removeItem(EPublishActions.PENDING_STOP_KIOSK_ACTION);
                }
                return [2 /*return*/];
            });
        }); };
        executePendingActions();
    }, [isGoldUser, onChangeStatus, onGenerate, record]);
    // Per-channel menu item disable logic
    var isStartChannelDisabled = function (info) {
        var _a;
        var channelEnabled = (_a = info === null || info === void 0 ? void 0 : info.is_channel_enabled) !== null && _a !== void 0 ? _a : false;
        var st = info === null || info === void 0 ? void 0 : info.status;
        return !channelEnabled || st === EVotingStatus.OPEN || st === EVotingStatus.CLOSED;
    };
    var isPauseChannelDisabled = function (info) {
        var _a;
        var channelEnabled = (_a = info === null || info === void 0 ? void 0 : info.is_channel_enabled) !== null && _a !== void 0 ? _a : false;
        var st = info === null || info === void 0 ? void 0 : info.status;
        return (!channelEnabled ||
            st === EVotingStatus.NOT_STARTED ||
            st === EVotingStatus.PAUSED ||
            st === EVotingStatus.CLOSED);
    };
    var isStopChannelDisabled = function (info) {
        var _a;
        var channelEnabled = (_a = info === null || info === void 0 ? void 0 : info.is_channel_enabled) !== null && _a !== void 0 ? _a : false;
        var st = info === null || info === void 0 ? void 0 : info.status;
        return !channelEnabled || st === EVotingStatus.CLOSED || st === EVotingStatus.NOT_STARTED;
    };
    var initializationReportNotGenerated = function () {
        var _a;
        return (((_a = record === null || record === void 0 ? void 0 : record.presentation) === null || _a === void 0 ? void 0 : _a.initialization_report_policy) ===
            EInitializeReportPolicy.REQUIRED && !(record === null || record === void 0 ? void 0 : record.initialization_report_generated));
    };
    // Encapsulated original disabled logic for each main action button
    var isStartButtonDisabled = function () {
        var allChannelsDisabled = isStartChannelDisabled(kioskModeEnabled) &&
            isStartChannelDisabled(onlineModeEnabled) &&
            isStartChannelDisabled(earlyVotingEnabled) &&
            isStartChannelDisabled(telephoneVotingEnabled);
        return (changingStatus ||
            [PublishStatus.GeneratedLoading].includes(status) ||
            allChannelsDisabled);
    };
    var isPauseButtonDisabled = function () {
        var allChannelsDisabled = isPauseChannelDisabled(kioskModeEnabled) &&
            isPauseChannelDisabled(onlineModeEnabled) &&
            isPauseChannelDisabled(earlyVotingEnabled) &&
            isPauseChannelDisabled(telephoneVotingEnabled);
        return (changingStatus ||
            [
                // PublishStatus.Void,
                PublishStatus.Generated,
                PublishStatus.GeneratedLoading,
            ].includes(status) ||
            allChannelsDisabled);
    };
    var isStopButtonDisabled = function () {
        var allChannelsDisabled = isStopChannelDisabled(kioskModeEnabled) &&
            isStopChannelDisabled(onlineModeEnabled) &&
            isStopChannelDisabled(earlyVotingEnabled) &&
            isStopChannelDisabled(telephoneVotingEnabled);
        return (changingStatus ||
            [
                // PublishStatus.Void,
                PublishStatus.Generated,
                PublishStatus.GeneratedLoading,
            ].includes(status) ||
            allChannelsDisabled);
    };
    return (_jsxs(_Fragment, { children: [_jsx(PublishActionsStyled.Container, { children: _jsx("div", { className: "list-actions", style: {
                        display: "flex",
                        gap: 0,
                        alignItems: "center",
                        justifyContent: "flex-end",
                    }, children: type === EPublishActionsType.List ? (_jsxs(_Fragment, { children: [showPublishColumns ? _jsx(SelectColumnsButton, {}) : null, showPublishFilters ? _jsx(FilterButton, {}) : null, canChangeStatus && canPublishStartVoting && (_jsxs(_Fragment, { children: [_jsx(StyledStatusButton, { onClick: function (e) {
                                            return setStartAnchorEl(e.currentTarget);
                                        }, className: "startVotingMenu", label: String(t("publish.action.startVotingPeriod")), disabled: isStartButtonDisabled(), children: _jsx(IconOrProgress, { st: PublishStatus.Started, Icon: PlayCircle }) }), _jsxs(Menu, { anchorEl: startAnchorEl, open: startMenuOpen, onClose: function () { return setStartAnchorEl(null); }, anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" }, children: [_jsx(StyledMenuItem, { disabled: isStartChannelDisabled(onlineModeEnabled) ||
                                                    initializationReportNotGenerated(), onClick: function () {
                                                    setStartAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_START_VOTING, ElectionEventStatus.Open, [VotingStatusChannel.Online]);
                                                }, children: t("publish.action.startOnlineVoting") }), _jsx(StyledMenuItem, { disabled: isStartChannelDisabled(kioskModeEnabled), onClick: function () {
                                                    setStartAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_START_VOTING, ElectionEventStatus.Open, [VotingStatusChannel.Kiosk]);
                                                }, children: t("publish.action.startKioskVoting") }), _jsx(StyledMenuItem, { disabled: isStartChannelDisabled(earlyVotingEnabled), onClick: function () {
                                                    setStartAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_START_VOTING, ElectionEventStatus.Open, [VotingStatusChannel.EarlyVoting]);
                                                }, children: t("publish.action.startEarlyVoting") }), _jsx(StyledMenuItem, { disabled: isStartChannelDisabled(telephoneVotingEnabled), onClick: function () {
                                                    setStartAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_START_VOTING, ElectionEventStatus.Open, [VotingStatusChannel.Telephone]);
                                                }, children: t("publish.action.startTelephoneVoting") })] })] })), canChangeStatus && canPublishPauseVoting && (_jsxs(_Fragment, { children: [_jsx(StyledStatusButton, { onClick: function (e) {
                                            return setPauseAnchorEl(e.currentTarget);
                                        }, className: "pauseVotingMenu", label: String(t("publish.action.pauseVotingPeriod")), disabled: isPauseButtonDisabled(), children: _jsx(IconOrProgress, { st: PublishStatus.Paused, Icon: PauseCircle }) }), _jsxs(Menu, { anchorEl: pauseAnchorEl, open: pauseMenuOpen, onClose: function () { return setPauseAnchorEl(null); }, anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" }, children: [_jsx(StyledMenuItem, { disabled: isPauseChannelDisabled(onlineModeEnabled), onClick: function () {
                                                    setPauseAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_PAUSE_VOTING, ElectionEventStatus.Paused, [VotingStatusChannel.Online]);
                                                }, children: t("publish.action.pauseOnlineVoting") }), _jsx(StyledMenuItem, { disabled: isPauseChannelDisabled(kioskModeEnabled), onClick: function () {
                                                    setPauseAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_PAUSE_VOTING, ElectionEventStatus.Paused, [VotingStatusChannel.Kiosk]);
                                                }, children: t("publish.action.pauseKioskVoting") }), _jsx(StyledMenuItem, { disabled: isPauseChannelDisabled(earlyVotingEnabled), onClick: function () {
                                                    setPauseAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_PAUSE_VOTING, ElectionEventStatus.Paused, [VotingStatusChannel.EarlyVoting]);
                                                }, children: t("publish.action.pauseEarlyVoting") }), _jsx(StyledMenuItem, { disabled: isPauseChannelDisabled(telephoneVotingEnabled), onClick: function () {
                                                    setPauseAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_PAUSE_VOTING, ElectionEventStatus.Paused, [VotingStatusChannel.Telephone]);
                                                }, children: t("publish.action.pauseTelephoneVoting") })] })] })), canChangeStatus && canPublishStopVoting && (_jsxs(_Fragment, { children: [_jsx(StyledStatusButton, { onClick: function (e) {
                                            return setStopAnchorEl(e.currentTarget);
                                        }, className: "stopVotingMenu", label: String(t("publish.action.stopVotingPeriod")), disabled: isStopButtonDisabled(), children: _jsx(IconOrProgress, { st: PublishStatus.Stopped, Icon: StopCircle }) }), _jsxs(Menu, { anchorEl: stopAnchorEl, open: stopMenuOpen, onClose: function () { return setStopAnchorEl(null); }, anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" }, children: [_jsx(StyledMenuItem, { disabled: isStopChannelDisabled(onlineModeEnabled) ||
                                                    isVotingPeriodEndDisallowed, onClick: function () {
                                                    setStopAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_STOP_VOTING, ElectionEventStatus.Closed, [VotingStatusChannel.Online]);
                                                }, children: t("publish.action.stopOnlineVoting") }), _jsx(StyledMenuItem, { disabled: isStopChannelDisabled(kioskModeEnabled), onClick: function () {
                                                    setStopAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_STOP_VOTING, ElectionEventStatus.Closed, [VotingStatusChannel.Kiosk]);
                                                }, children: t("publish.action.stopKioskVotingPeriod") }), _jsx(StyledMenuItem, { disabled: isStopChannelDisabled(earlyVotingEnabled), onClick: function () {
                                                    setStopAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_STOP_VOTING, ElectionEventStatus.Closed, [VotingStatusChannel.EarlyVoting]);
                                                }, children: t("publish.action.stopEarlyVoting") }), _jsx(StyledMenuItem, { disabled: isStopChannelDisabled(telephoneVotingEnabled), onClick: function () {
                                                    setStopAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_STOP_VOTING, ElectionEventStatus.Closed, [VotingStatusChannel.Telephone]);
                                                }, children: t("publish.action.stopTelephoneVoting") })] })] })), canWrite && canPublishChanges && (_jsx(StatusButton, { Icon: Publish, onClick: function () { return handlePublish(false); }, st: PublishStatus.Generated, label: String(t("publish.action.publish")), disabledStatus: [], disabled: changingStatus }))] })) : (_jsxs(_Fragment, { children: [canWrite && canPublishRegenerate && (_jsx("div", { className: "list-actions", style: { paddingBottom: "4px" }, children: _jsx(StatusButton, { Icon: RotateLeft, disabledStatus: [], st: PublishStatus.Generated, label: String(t("publish.action.generate")), onClick: function () { return handlePublish(true); } }) })), canWrite && (_jsx(PublishExport, { ballotPublicationId: ballotPublicationId }))] })) }) }), _jsx(Dialog, { handleClose: function (flag) {
                    if (flag && currentCallback) {
                        currentCallback(); // Execute the saved callback
                    }
                    setShowDialog(false); // Close the dialog
                    setCurrentCallback(null); // Reset the callback
                }, open: showDialog, title: String(t("publish.dialog.title")), ok: String(t("publish.dialog.ok")), cancel: String(t("publish.dialog.ko")), variant: "info", children: _jsx(Typography, { variant: "body1", children: dialogText }) })] }));
};
var templateObject_1, templateObject_2, templateObject_3;
